import { AudioElement } from "../types/twilio-video";

export const CreateAudioElement = (src: string, loop?: boolean) => {
	const audioVar = new Audio(src) as AudioElement;
	audioVar.crossOrigin = "anonymous";
	audioVar.loop = loop ? loop : false;
	audioVar.volume = 1.0;
	return audioVar;
}